<template>
  <button
    class="
      cta cta--content-wrap
      hover-enlarge-image
      image-overlay
      hover-icon-move
    "
    @click="openModal"
  >
    <slot name="picture"></slot>
    <div class="cta__image-content">
      <p class="heading-h5 m-b--8">{{ name }}</p>
      <span  class="paragraph-note">
        {{ title }}
        <i
          class="icon icon-chevronright icon-color--white icon--xxs"
          aria-hidden="true"
        />
      </span>
    </div>
  </button>

  <base-modal injection-name="injectedIsOpenTeamMember" @update:state="childEmits"  modal-class="team-member-modal">
    <template #modal-content="{ closeModal }">
      <div class="base-model__content">
        <div class="base-model__header">
          <button role="button" aria-label="Dismiss modal" class="button--text button--icon base-model__header-close" :onClick="closeModal">
            <i class="icon icon-close icon--xs" aria-hidden="true"></i>
          </button>
        </div>
        <div class="base-model__body">   
          <div class="modal__content-image">    
            <slot name="picture"></slot>
          </div>
          <div class="modal__content-text">
            <h2 class="heading--separator m-b--16">{{ name }}</h2>
            <p class="fs-14 m-b--48">{{ title }}</p>
            <slot name="bio"></slot>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script setup>
import BaseModal from '../BaseModal/BaseModal.vue'

import { provide, ref } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});

const isOpen = ref(false);

const openModal = (e) => {
  isOpen.value = true;
};

const closeModal = (e) => {
  isOpen.value = false;
};

const childEmits = (value) => {
    if (value === 'isClosed') {
        closeModal()
    }
}

provide('injectedIsOpenTeamMember', isOpen);

</script>
